export default function Box() {
  throw new Error(
    '"Box" is a native component only, no web version is available: Use "Row" and "Col" for web applications.'
  );
}
